<template>
    <div class="telekom-angebote-magentatv">
        <BasicBreadcrumb
            :items="[
                { label: 'Telekom Angebote', to: `/markt/${storeslug}/telekom-angebote` },
                { label: 'MagentaTV', to: '' }
            ]"
        />
        <div class="lg:container mx-auto p-8 lg:px-0 tariffSlider">
            <ContentHeroBanner
                v-for="banner in heroBanner?.items" :key="banner?.id"
                :img-mobile="banner?.imageUrlMobile"
                :img-desktop="banner?.imageUrl"
                :title="banner?.title"
                :background-img-mobile="backgroundImgMobile"
                :background-img-desktop="backgroundImgDesktop"
            />
            <div v-if="magentaTVOffer?.items?.length" class="mt-4">
                <div v-for="offerMagentaTV in magentaTVOffer.items" :key="offerMagentaTV.id">
                    <div class="mb-4 text-xs whitespace-pre-line" v-html="offerMagentaTV.text"/>
                    <!-- Mobile Image -->
                    <div class="sm:hidden w-full rounded-3xl bg-center"> 
                        <img 
                            class="rounded-3xl"
                            :src="offerMagentaTV.imageUrlMobile || offerMagentaTV.imageUrl" 
                            :alt="offerMagentaTV.title" 
                            :title="offerMagentaTV.title"
                        >
                    </div>
                    <!-- Desktop Image -->
                    <div class="hidden sm:flex sm:items-center w-full rounded-3xl bg-center">
                        <img 
                            class="w-full rounded-3xl"
                            :src="offerMagentaTV.imageUrl" 
                            :alt="offerMagentaTV.title" 
                            :title="offerMagentaTV.title"
                        >
                    </div>
                </div>
            </div>
            <div class="py-2">
                <BasicBtErrorBoundary>
                    <TariffOfferSlider
                        :key="Date.now()"
                        :tenant-id="tenantId"
                        :magenta-t-v="true"
                        :title="'Unsere aktuellen TOP-ANGEBOTE der Telekom -<br/>vor Ort im Markt für Sie verfügbar'"
                        :store="currentStore"
                        :link-path="'noLink'"
                    />
                </BasicBtErrorBoundary>
            </div>
            <div class="my-8 w-full" :class="isVisibleWMVideo ? 'flex gap-4' : 'block'">
                <!-- Erstes Video -->
                <div v-if="isVisibleWMVideo" class="w-full md:w-1/2">
                    <div style="position: relative; padding-top: 56.25%;">
                        <iframe
                            title="Alle Spiele nur bei MagentaTV"
                            aria-label="Alle Spiele nur bei MagentaTV"
                            src="https://customer-tlje1rwg5ehqb0q0.cloudflarestream.com/138b91b91562dd7d6e04e26003b07ad2/iframe?poster=https%3A%2F%2Fcustomer-tlje1rwg5ehqb0q0.cloudflarestream.com%2F138b91b91562dd7d6e04e26003b07ad2%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600"
                            style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%;"
                            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                            allowfullscreen="true"
                            class="rounded-3xl"
                        />
                    </div>
                </div>
                <!-- Zweites Video -->
                <div :class="isVisibleWMVideo ? 'w-full md:w-1/2' : 'w-full'">
                    <div style="position: relative; padding-top: 56.25%;">
                        <iframe
                            title="Was ist MagentaTV"
                            aria-label="Was ist MagentaTV"
                            src="https://customer-tlje1rwg5ehqb0q0.cloudflarestream.com/00755648f207894b9e4467d4b6ac2aae/iframe?poster=https%3A%2F%2Fcustomer-tlje1rwg5ehqb0q0.cloudflarestream.com%2F00755648f207894b9e4467d4b6ac2aae%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600"
                            style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%;"
                            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                            allowfullscreen="true"
                            class="rounded-3xl"
                        />
                    </div>
                </div>
            </div>
            <div class="py-2 magentaTVText">
                <div>
                    <!-- Tab Buttons -->
                    <div class="flex mb-4 gap-4">
                        <button
                            v-for="(tab, index) in tabs"
                            :key="index"
                            :class="[
                            'cursor-pointer btn-primary px-8 py-3 font-bold mt-4 p-4 text-center',
                            activeTab === index ? 'bg-magenta text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                            ]"
                            @click="selectTab(index)"
                        >
                            {{ tab.label }}
                        </button>
                    </div>
                    <!-- Tab Inhalt -->
                    <div class="p-4" v-html="tabs?.[activeTab]?.content || ''"/>
                </div>
            </div>
            <div class="py-8 magentaTVText">
                <h1 class="text-3xl font-bold mb-6">Häufig gestellte Fragen zu MagentaTV</h1>
                <div v-for="(faq, index) in faqs" :key="index" class="border-b">
                    <button 
                        class="w-full text-left py-4 flex justify-between items-center focus:outline-none" 
                        @click="toggle(index)"
                    >
                        <span class="font-semibold">{{ faq.question }}</span>
                        <span class="text-xl">
                        {{ activeIndex === index ? "-" : "+" }}
                        </span>
                    </button>
                    <div 
                        v-show="activeIndex === index" 
                        class="pb-4 text-gray-700 transition-all duration-300"
                        v-html="faq.answer"
                    />
                </div>
            </div>
            <div class="pt-4 pb-12 container mx-auto font-bold text-paragraph text-2xl text-center">
                Alle Informationen und Angebote zu den Themen Mobilfunk,<br>
                Internet, Glasfaser und Kombipakete findest du hier
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-8 pb-8">
                <TariffSubPageTeaser
                    :background="backgroundTile"
                    :icon="iconContract"
                    url="/telekom-angebote/mobilfunk"
                    :title="'Handy mit Vertrag'"
                />
                <TariffSubPageTeaser
                    :background="backgroundTile"
                    :icon="iconInternet"
                    url="/telekom-angebote/internet"
                    :title="'Internet'"
                />
                <TariffSubPageTeaser
                    :background="backgroundTile"
                    :icon="iconOptical"
                    url="/telekom-angebote/glasfaser"
                    :title="'Glasfaser'"
                />
                <TariffSubPageTeaser
                    :background="backgroundTile"
                    :icon="iconCombi"
                    url="/telekom-angebote/kombipakete"
                    :title="'Kombi-Pakete'"
                />
            </div>
        </div>
        <TariffEyeCatcher />
    </div>
</template>

<script setup lang="ts">
    import type { ContentBlock } from '~~/models/Tariff/ContentBlock';
    import { ContentBlockType } from '~~/models/Tariff/ContentBlock';

    import backgroundImgMobile from '~/assets/img/tariff-topic/telekom/ssb_BG_mobile.png';
    import backgroundImgDesktop from '~/assets/img/tariff-topic/telekom/ssb_BG.png';
    import backgroundTile from '~/assets/img/tariff-topic/telekom/bg_icons.png';
    import iconContract from '~/assets/img/tariff-topic/telekom/two/mobilfunk.png';
    import iconInternet from '~/assets/img/tariff-topic/telekom/two/internet.png';
    import iconOptical from '~/assets/img/tariff-topic/telekom/two/glasfaser.png';
    import iconCombi from '~/assets/img/tariff-topic/telekom/two/kombi-pakete.png';

    const tenantId: string = "692ef56ad1b19b630ac62ff3";
    const currentStore = useCurrentStore();

    const route = useRoute();
    const storeslug = route.params.storeslug;

    const storeName = currentStore?.value?.name ?? 'expert';
    const pageTitle = 'Telekom MagentaTV bei ' + storeName + ' | TV & Streaming Angebote bei expert';
    const pageDescription = 'MagentaTV bei ' + storeName + ': Fernsehen, Serien & Streaming in einem Paket. Mit Netflix, Disney+ & RTL+ Optionen. Jetzt Telekom TV Angebot sichern!';
    useHead({
        title: pageTitle,
        meta: [{ name: 'description', content: pageDescription }
        ]
    });

    const isVisibleWMVideo = new Date() <= new Date('2026-05-31');
    
    const fetchContentBlock = (type: ContentBlockType) =>
    useFetch<{ items: ContentBlock[] }>(
        `/api/nea/tariff-service/contentBlock`,
        {
            query: {
                page: 0,
                validOnly: true,
                pageSize: 1,
                type
            }
        }
    );

    const { data: heroBanner } = await fetchContentBlock(ContentBlockType.TELEKOM_MAGENTA_TV_BANNER);
    const { data: magentaTVOffer } = await fetchContentBlock(ContentBlockType.TELEKOM_MAGENTA_TV_OFFER);

    const activeIndex = ref<number | null>(null);
    function toggle(index: number) {
        activeIndex.value = activeIndex.value === index ? null : index;
    }
    const faqs = [
        {
            question: "Welche Funktionen bietet MagentaTV?",
            answer: `
            <p>Mit MagentaTV profitieren Sie von einer Vielzahl von Funktionen, wobei einige exklusiv bei der Nutzung über MagentaTV One oder MagentaTV Stick verfügbar sind:</p>
            <ul class="list-disc ml-6">
                <li>Aufnahmefunktion: Nehmen Sie Ihre Lieblingssendungen oder -serien ganz einfach einmalig oder fortlaufend auf und genießen Sie sie zu einem beliebigen Zeitpunkt.</li>
                <li>Timeshift: Unterbrechen Sie das laufende Programm und setzen Sie es zu einem späteren Zeitpunkt nahtlos fort. Zeitversetztes Fernsehen war noch nie so einfach.</li>
                <li>Restart: Springen Sie bei ausgewählten Inhalten zurück oder starten Sie sie ganz von vorne. Bei laufenden Sendungen bestimmen Sie selbst, wann es los- und weitergeht.</li>
                <li>Replay: Wiederholen Sie ausgewählte Sendungen bis zu sieben Tage nach der Ausstrahlung. Beachten Sie, dass diese Funktion nicht bei allen Sendern oder Sendungen verfügbar ist.</li>
                <li>Übergreifende Suche: Mit dieser Funktion finden Sie Ihre Lieblingsinhalte schnell und einfach, unabhängig davon, ob es sich um Fernsehsendungen oder On-Demand-Inhalte handelt.</li>
                <li>MagentaTV Sprachassistent: Steuern Sie die Suche, die Lautstärkeregelung und weitere Funktionen bequem per Sprache mit dem MagentaTV Sprachassistenten.</li>
            </ul>
            `
        },
        {
            question: "Was ist MagentaTV SmartStream?",
            answer: `
            <p>Mit dem Tarif MagentaTV SmartStream genießen Sie nicht nur alle Vorteile von MagentaTV Smart, sondern zusätzlich das Streaming-Angebot von Netflix Standard mit Werbung und Disney+ Standard mit Werbung. Damit haben Sie Zugriff auf noch mehr Filme und Serien – in bester Full-HD-Qualität.</p>
            <p>Nach der Bereitstellung von MagentaTV SmartStream erhalten Sie jeweils eine E-Mail zur Aktivierung Ihres Netflix- und Disney+ -Kontos. Sie können die Inhalte beider Streaming-Dienste auf zwei Geräten gleichzeitig in Full HD streamen.</p>
            <p>Standardmäßig umfasst MagentaTV SmartStream Netflix Standard mit Werbung und Disney+ Standard mit Werbung. Falls Sie werbefreie Inhalte bevorzugen, haben Sie jederzeit die Möglichkeit, ein Upgrade auf ein passendes Abo der jeweiligen Streaming-Anbieter vorzunehmen.</p>
            <p>
                <strong>Netflix-Upgrade-Optionen:</strong>
                <ul class="list-disc ml-6">
                    <li><strong>Netflix Standard (werbefrei):</strong> Zwei parallele Streams in Full HD.</li>
                    <li><strong>Netflix Premium:</strong> Vier parallele Streams in UHD.</li>
                </ul>
            </p>
            <p>
                <strong>Disney+-Upgrade-Optionen:</strong>
                <ul class="list-disc ml-6">
                    <li><strong>Disney+ Standard (werbefrei):</strong> Zwei parallele Streams in Full HD.</li>
                    <li><strong>Disney+ Premium:</strong> Vier parallele Streams in UHD.</li>
                </ul>
            </p>
            <p>Wählen Sie Ihr gewünschtes Upgrade ganz bequem während der Bestellung oder jederzeit im Nachgang.</p>
            `
        },
        {
            question: "Für welche Geräte ist MagentaTV Smart geeignet?",
            answer: `
            <p>Sie können MagentaTV mit einer MagentaTV One, einem MagentaTV Stick oder via App auf dem Fernseher schauen. Auch viele Smart TVs mit Android TV (ab 7.1), Samsung Smart TVs (ab 2018) sowie der Fire Stick (ab OS 6) werden unterstützt. Für MagentaTV Basic benötigen Sie eine Magenta TV One, den MagentaTV Stick oder ein AppleTV 4K.</p>
            `
        },
        {
            question: "Was passiert mit meinem bestehenden Netflix-Abo wenn ich zu MagentaTV SmartStream oder MagentaTV MegaStream wechsle?",
            answer: `
            <p>Sie können Ihr bestehendes Netflix-Konto in wenigen Schritten mit dem MagentaTV Netflix Tarif oder MagentaTV MegaStream Tarif verbinden. Sobald das geschehen ist, wird die Abrechnung über Netflix gestoppt. Die Eigenschaften wie Profile und Empfehlungen Ihres Netflix-Kontos bleiben dabei erhalten. Im MagentaTV SmartStream Tarif ist das Netflix Standard-Abo mit Werbung enthalten (2 Streams in Full HD). Während des Bestellvorgangs haben Sie die Möglichkeit, auf Ihr Wunsch-Abo zu wechseln. Sie können zwischen dem Netflix Standard-Abo (2 gleichzeitige Streams, Full HD, werbefrei) oder dem Netflix Premium-Abo (4 gleichzeitige Streams, UHD, werbefrei) wählen. Der MagentaTV MegaStream Tarif beinhaltet standardmäßig das Netflix Standard-Abo (2 gleichzeitige Streams, Full HD, werbefrei). Auch hier besteht die Option, während des Bestellprozesses auf das Premium-Abo (4 gleichzeitige Streams, UHD) umzusteigen.</p>
            `
        },
        {
            question: "Ich habe schon ein Disney+ Abo. Kann ich trotzdem ein Disney+ Abo im MagentaTV SmartStream oder MegaStream Tarif über die Telekom in Anspruch nehmen?",
            answer: `
            <p>Ja, Sie können Ihr bestehendes Disney+ Abo behalten.</p>
            <p><span class="underline font-semibold">Variante 1:</span> Verfügen Sie bereits über ein gleichwertiges oder niedrigeres Disney+ Abo-Modell, das Sie direkt bei Disney abgeschlossen habenwird Disney Ihr bestehendes Abo pausieren und erst fortsetzen, sobald die Laufzeit Ihres Abos bei der Telekom endet. Nach Abschluss der Buchung und Verknüpfung Ihres bestehenden Disney+ Accounts erhalten Sie von Disney+ eine entsprechende E-Mail mit allen notwendigen Informationen zur Pausierung Ihres bestehenden Abonnements.</p>
            <p><span class="underline font-semibold">Variante 2:</span> Verfügen Sie bereits über ein höherwertiges Disney+ Abo-Modell, das Sie direkt bei Disney abgeschlossen habenund wechseln auf ein neues, niedrigeres Disney+ Abo-Modell bei der Telekom (z.B. Disney+ Standard mit Werbung), dann können Sie das bestehende Disney+ Abo selbständig kündigen, um mehrfache Abrechnungen zu vermeiden. Dies können Sie in Ihren Disney+ Kontoeinstellungen tun. Nach Abschluss der Buchung und Verknüpfung Ihres bestehenden Disney+ Accounts erhalten Sie von Disney+ eine E-Mail mit entsprechenden Informationen. Für weitere Fragen und eine mögliche Rückerstattung für Jahresabo-Kunden wenden Sie sich bitte an denDisney+ Kundenservice.</p>
            <p><span class="underline font-semibold">Variante 3:</span> Wenn Sie eine abweichende E-Mailadresse nutzen, um Ihr neues Disney+ Konto bei der Telekom zu aktivieren, erstellen Sie ein zusätzliches Disney+ Konto. Dies ist möglich, kann aber dazu führen, dass Ihnen Gebühren sowohl von The Walt Disney Company (Benelux) B.V. als auch der Telekom in Rechnung gestellt werden.</p>
            `
        }
    ];

    // Aktiver Tab-Index
    const activeTab = ref(0)

    // Tab-Daten
    const tabs = [
        { label: 'MagentaTV entdecken', content: `
            <p class="font-bold text-2xl">über MagentaTV</p>
            <p>
                <strong>MagentaTV verbindet alle deine Fernsehwelten</strong><br/>
                Fernsehen, Serien und Filme mit MagentaTV+ sowie Streaming-Partner
                <ul class="list-disc ml-6">
                    <li>Beste Fernseh-Unterhaltung mit über 180 Sender (Über 180 Sender gilt für TV Receiver, bei Nutzung über MagentaTV Stick oder App sind rund 100 Sender verfügbar), davon 160 in hervorragender HD-Qualität und 3 in UHD-Qualität. Aktuelle Nachrichten, Lieblingsserien und Blockbuster. Immer genau das, worauf Sie gerade Lust haben. Denn bei MagentaTV bestimmen Sie das Programm.</li>
                    <li>MagentaTV+ mit internationalen Top-Serien & Filmen sowie dem Besten von ARD & ZDF. Alles inklusive. Bei MagentaTV ist das + immer dabei.</li>
                    <li>Disney+, RTL+, Netflix, Prime Video, WOW, DAZN und Apple+. Alle auf einer Plattform. Mit übergreifender Suchfunktion. In einheitlichem Look. Keine zusätzlichen Apps oder Geräte nötig. MagentaTV vereint mehrere Entertainmentwelten in einer.</li>
                    <li>Ihre persönlichen Lieblings-Apps auf einen Blick: Passen Sie Ihre Favoriten ganz individuell auf der persönlichen Schnellstartleiste an und gelangen Sie so bequem und schnell zum Lieblingsinhalt. Nutze die Persönliche Schnellstartleiste mit MagentaTV One, MagentaTV Stick sowie der MagentaTV App auf iOS und Android.</li>
                    <li>Steuern Sie die Suche, die Lautstärkeregelung und weitere Funktionen bequem per Sprache.</li>
                </ul>
            </p>
            ` 
        },
        { label: 'MagentaTV mit Telekom Internetanschluss', content: `
            <p class="font-bold text-2xl">MagentaTV mit Telekom Internetanschluss</p>
            <p>Mit MagentaTV erleben Sie erstklassiges Fernsehen über IPTV mit herausragender Bildqualität und hochauflösendem Programm. Bei Ihrer Entscheidung für MagentaTV stehen Ihnen verschiedene Tarife zur Auswahl:</p>
            <p>
                <ul class="list-disc ml-6">
                    <li>MagentaTV Smart</li>
                    <li>MagentaTV SmartStream</li>
                    <li>MagentaTV MegaStream</li>
                </ul>
            </p>
            <p>
                Beste Fernseh-Unterhaltung mit über 180 Sender (Über 180 Sender gilt für TV Receiver, bei Nutzung über MagentaTV Stick oder App sind rund 100 Sender verfügbar), 
                davon 160 in hervorragender HD-Qualität und 3 in UHD-Qualität. Außerdem nutzen Sie in allen Tarifen die Restart-Funktion, mit der Sie viele laufende Sendungen 
                einfach von Anfang an sehen. So verpassen Sie garantiert nie wieder Ihre Lieblingsserie. Unabhängig davon, ob Sie bereits Abonnements bei Streaming-Diensten 
                haben oder solche abschließen möchten, bietet MagentaTV eine bequeme Integration verschiedener Streaming-Dienste. Dazu gehören RTL+, Netflix, Disney+, 
                Amazon Prime Video, DAZN, WOW und Apple+. Auf diese Weise können Sie Filme und Videos verschiedener Anbieter über eine einzige Oberfläche streamen und ersparen 
                sich das lästige Wechseln zwischen verschiedenen Apps.
            </p>
            ` 
        },
        { label: 'MagentaTV ohne Telekom Internetanschluss', content: `
            <p class="font-bold text-2xl">MagentaTV ohne Telekom Internetanschluss</p>
            <p>
                MagentaTV mit MagentaTV App buchen – unabhängig vom Internetanbieter fernsehen
                Spannende Filme online schauen, neueste Serien online streamen, packende Live-Events genießen – das alles und mehr auf deinem Handy, Tablet oder Laptop zu Hause oder unterwegs. Bestimme dein TV-Programm ab jetzt selbst mit MagentaTV unabhängig vom Internetanbieter.
            </p>
            <p>
                <strong>Was bedeutet unabhängiges Internet-Fernsehen?</strong><br/>
                Verabschiede dich von Receivern, Satellitenschüsseln und dem lästigen Kabelsalat! Mit MagentaTV via Internetempfang erlebst du die Inhalte ganz unkompliziert 
                über eine IPTV App auf deinem Smartphone, Tablet, Notebook oder Fernseher. Diese TV-Option ist extrem flexibel, mobil und verfügbar, wo auch immer du es 
                möchtest. Das Beste daran: Sie ist anschlussunabhängig. Du benötigst keinen speziellen Telekom Breitbandanschluss, sondern kannst einfach deinen bereits 
                vorhandenen Internetanschluss nutzen – ganz gleich von welchem Anbieter.
            </p>
            <p>
                <strong>Was bietet dir Online-TV?</strong><br/>
                Unabhängig vom Internetanbieter hast du mit MagentaTV Zugriff auf eine riesige Auswahl an TV-Sendern, davon über 100 sogar in erstklassiger HD-Qualität. 
                Bist du ein Serienjunkie? Dann nutze das TV-Streaming-Angebot und wähle aus einer Vielfalt an internationalen Top-Serien aus. Möchtest du das volle Programm? 
                Dann buche frei nach deinen Wünschen weitere Pakete wie Disney+ oder das TV-Paket Family für noch abwechslungsreichere Unterhaltung und mehr Auswahl bei 
                deinem TV-Erlebnis hinzu.
            </p>
            <p>
                <strong>OTT-TV genießen – so leicht funktioniert das</strong><br/>
                Das Anschauen von Fernsehen über das Internet wird als „Over-the-top“ (OTT) bezeichnet. Egal ob fesselnde Filme, komplette Staffeln deiner Lieblingsserie, 
                Sport-Events, Live-Musik-Shows oder das Programm der TV-Sender – die Vielfalt an Online-Inhalten ist schier grenzenlos. Wenn dir genau diese Flexibilität bei 
                den Inhalten wichtig ist, wird dich MagentaTV OTT begeistern, denn unsere OTT-Inhalte übertreffen garantiert alles, was du bisher erlebt hast. Unabhängig vom 
                Internetanbieter kannst du dich für diese Möglichkeit des Internet-Fernsehens entscheiden. Buche MagentaTV einfach bequem online, installiere die TV-App und 
                schon erlebst du großes TV-Vergnügen auf deinem Smartphone, Tablet, Notebook oder Smart TV. Völlig ortsunabhängig und flexibel. Teste jetzt MagentaTV Flex, 
                unabhängig vom Internetanbieter, und genieße die Freiheit beim Fernsehen in vollen Zügen. Möchtest du ein anderes Fernsehangebot, wie MagentaTV Smart, 
                MagentaTV SmartStream, MagentaTV MegaStream oder MagentaTV Smart Flex nutzen, kannst du den MagentaTV Flex Tarif monatlich kündigen.
            </p>
            <p>
                <strong>Häufig gestellte Fragen zum Thema MagentaTV ohne Telekom Internetanschluss</strong><br/>
                Auf welchen Geräten kann ich MagentaTV unabhängig vom Internetanbieter nutzen?<br/>
                Du kannst MagentaTV auf all deinen Geräten und ohne Kabelsalat empfangen:
                <ul class="list-disc ml-6">
                    <li>MagentaTV via App auf dem Smartphone oder Tablet, TV und im Webbrowser.</li>
                    <li>Auf dem Fernseher via TV App, MagentaTV Stick, Amazon Fire TV (ab OS 6), Apple TV (ab 4. Generation) oder Magenta TV One.</li>
                    <li>Direkt auf deinem Samsung Smart TV (ab Modelljahr 2018) oder auf Smart TV-Geräten mit Android TV (ab Android OS Version 7.1) ohne zusätzliche Hardware.</li>
                </ul>
            </p>
            `
        },
    ]

    // Funktion zum Wechseln
    function selectTab(index: number) {
        activeTab.value = index
    }

    await checkStoreHasPage(tenantId);

    watch(currentStore, async (store) => {
        const storeId: string = store?.id;
        if (!storeId) {
            return;
        }
        await checkStoreHasPage(tenantId);
    });   

</script>
<style lang="postcss">
    .tariffSlider .vueperslides--fixed-height.vueperslides--bullets-outside {
        margin-bottom: 1em;
    }

    .magentaTVText p {
        margin-bottom: 25px;
    }

</style>